export default [
    {
		path: '/signup/:stage?/:hash?',
		name: 'Signup',
		component: () => import('@/views/signup/Signup.vue'),
		props: true,
		meta: {
			layout: 'Signup',
			abilities: [],
		}
	},
]